import _ from 'lodash';
import moment from 'moment';
import TagEntity from '../entities/TagEntity';
import SpendingBudgetData from '../entities/SpendingBudgetData';
import TransactionEntity from '../entities/TransactionsEntity';

export default class SpendingsParser {
  parseSpendingData(data, type) {
    const spendData = [];
    const currentMonth = moment().format('YYYY-MM');
    const lastMonth = moment(currentMonth)
      .subtract(1, 'months')
      .format('YYYY-MM');
    _.map(data.buckets, (tag) => {
      const tagEntity = new TagEntity();
      tagEntity.key = tag.key;
      tagEntity.type = type;
      _.map(tag.month.buckets, (monthlySpend) => {
        if (
          moment(monthlySpend.key_as_string).format('YYYY-MM') === currentMonth
        ) {
          tagEntity.currentSpendAmount =
            monthlySpend.spend.buckets[0].amount.value;
        } else if (
          moment(monthlySpend.key_as_string).format('YYYY-MM') === lastMonth
        ) {
          tagEntity.previousSpendAmount =
            monthlySpend.spend.buckets[0].amount.value;
        } else {
          tagEntity.previousSpendAmount = 0;
          tagEntity.currentSpendAmount = 0;
        }
      });
      if (tag.cat_name) {
        tagEntity.name = tag.cat_name.buckets[0].key;
      }
      if (tag.tag_name) {
        tagEntity.name = tag.tag_name.buckets[0].key;
      }
      spendData.push(tagEntity);
    });
    return spendData;
  }

  parseBreakDownOfSpendResponse(response) {
    const spendData = [];
    const otherAccountsTags = response.aggregations.other_accounts.tags;
    const otherAccountsCategories =
      response.aggregations.other_accounts.categories;
    const creditCardTags = response.aggregations.credit_cards.tags;
    const creditCardCategories = response.aggregations.credit_cards.categories;
    _.forEach(
      this.parseSpendingData(otherAccountsTags, 'tags'),
      (breakDown) => {
        spendData.push(breakDown);
      }
    );
    _.forEach(
      this.parseSpendingData(otherAccountsCategories, 'categories'),
      (breakDown) => {
        spendData.push(breakDown);
      }
    );
    _.forEach(this.parseSpendingData(creditCardTags, 'tags'), (breakDown) => {
      spendData.push(breakDown);
    });
    _.forEach(
      this.parseSpendingData(creditCardCategories, 'categories'),
      (breakDown) => {
        spendData.push(breakDown);
      }
    );
    return spendData;
  }

  parseBudgetConnectionData(response) {
    const budgetData = [];
    const budgetDataTags = response.tag_budgets;
    const budgetDataCategories = response.category_budgets;
    if (budgetDataTags.length > 0) {
      _.map(budgetDataTags, (budget) => {
        if (budget.tag.value !== 'Earnings') {
          const spendingBudgetData = new SpendingBudgetData();
          spendingBudgetData.key = budget.tag.id.toString();
          spendingBudgetData.value = budget.tag.value;
          spendingBudgetData.name = budget.tag.value;
          spendingBudgetData.budgetAmount = budget.target_amount.value;
          spendingBudgetData.current_month = budget.target_amount.value;
          spendingBudgetData.isArchived = budget.tag.archived;
          spendingBudgetData.path = budget.tag.path;
          spendingBudgetData.category_budgets = false;
          spendingBudgetData.tag_budget = true;
          budgetData.push(spendingBudgetData);
        }
      });
    }
    if (budgetDataCategories.length > 0) {
      _.map(budgetDataCategories, (budget) => {
        if (budget.category.value !== 'Earnings') {
          const spendingBudgetData = new SpendingBudgetData();
          spendingBudgetData.key = budget.category.id.toString();
          spendingBudgetData.value = budget.category.value;
          spendingBudgetData.name = budget.category.value;
          spendingBudgetData.budgetAmount = budget.target_amount.value;
          spendingBudgetData.isArchived = budget.category.archived;
          spendingBudgetData.path = budget.category.path;
          spendingBudgetData.category_budgets = true;
          spendingBudgetData.tag_budget = false;
          budgetData.push(spendingBudgetData);
        }
      });
    }
    return budgetData;
  }

  parseTagConnectionData(response) {
    const tagList = [];
    const tagged_tags = response.tags;
    const category_tags = response.categories;
    _.map(tagged_tags, (tag) => {
      if (tag.value !== 'Earnings') {
        const tagEntity = new TagEntity();
        tagEntity.key = tag.id.toString();
        tagEntity.value = tag.value;
        tagEntity.isArchived = tag.archived || false;
        tagEntity.path = tag.path;
        tagEntity.tagBudget = true;
        tagEntity.categoryBudget = false;
        tagList.push(tagEntity);
      }
    });
    _.map(category_tags, (tag) => {
      if (tag.value !== 'Earnings') {
        const tagEntity = new TagEntity();
        tagEntity.key = tag.id.toString();
        tagEntity.value = tag.value;
        tagEntity.isArchived = tag.archived || false;
        tagEntity.path = tag.path;
        tagEntity.tagBudget = false;
        tagEntity.categoryBudget = true;
        tagList.push(tagEntity);
      }
    });
    return tagList;
  }

  parseTransactionListData(response) {
    const transactionsList = {
      total: response.hits.total,
      transactions: [],
    };
    const transactionsResponse = response.hits.hits;
    _.map(transactionsResponse, (transaction) => {
      const transactionEntity = new TransactionEntity();
      transactionEntity.id = transaction._id;
      transactionEntity.date = transaction._source.details.when;
      transactionEntity.description =
        transaction._source.details.narrative.small;
      if (transaction._source.metadata.where.city) {
        transactionEntity.description = `${transactionEntity.description} ${transaction._source.metadata.where.city}`;
      }
      transactionEntity.type = transaction._source.details.type;
      if (transaction._source.metadata.categories) {
        transactionEntity.tag =
          transaction._source.metadata.categories[0].value;
      }
      if (transaction._source.metadata.tags) {
        transactionEntity.tag = transaction._source.metadata.tags[0].value;
      }
      transactionEntity.amount = transaction._source.details.amount.value;
      transactionEntity.account = transaction._source.this_account.number;
      !transaction._source.details.posted
        ? (transactionEntity.inProgress = true)
        : (transactionEntity.inProgress = false);
      transactionsList.transactions.push(transactionEntity);
    });
    return transactionsList;
  }
}
